import type { ValueOf } from "@/utils/valueOf";

export const DividerVariant = {
  DARK: "dark",
  LIGHT: "light",
} as const;
export type DividerVariant = ValueOf<typeof DividerVariant>;
